import { useAppSelector } from "@src/reduxStore";
import { FC } from "react";
import { useIntl } from "react-intl";

const LinkToRPInstructionCenter: FC = ({ children }) => {
  const config = useAppSelector(state => state.common.config);
  const intl = useIntl();

  return (
    <a
      href={intl.formatMessage(
        {
          id: "RPInstructionCenterUrl",
          defaultMessage:
            "{supportUrl}/hc/fi/categories/115000864945-Luotettava-Kumppani",
        },
        {
          supportUrl: config?.supportUrl,
        }
      )}
      target="_blank"
      rel="noreferrer noopener"
    >
      {children}
    </a>
  );
};

export default LinkToRPInstructionCenter;
